import React from 'react'
import { FaAngleDown } from 'react-icons/fa'
import {ExpandButtonWrap} from './expand-button.style'

export const ExpandButton = ({onClick, ...props}) => {
    return (
        <ExpandButtonWrap className="menu-expand" onClick={onClick} {...props}>
            <FaAngleDown className="icon" />
        </ExpandButtonWrap>
    )
}

